import { useEffect, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { Button, Checkbox, Col, Drawer, Form, Row, Spin } from "antd";
import PropTypes from "prop-types";

import { Modals } from "scripts/settings";
import API from "scripts/api";
import Resources from "scripts/resources";

const Component = ({ data = {}, onUpdate, options: { courses = [] } }) => {
  const initialState = {};
  const [state, setState] = useState(initialState);
  const { loading, submitting, visible } = state;
  const { firstName, id, lastName } = data;
  const { hash, pathname, search } = useLocation();
  const [form] = Form.useForm();
  const [checkedList, setCheckedList] = useState();

  const navigate = useNavigate();

  const handleSubmit = () => {
    if (!submitting) {
      form.validateFields().then((values) => {
        setState((prevState) => ({ ...prevState, submitting: true }));

        API.user
          .course(id, values)
          .then(() => {
            onUpdate(null, true);
            navigate(-1);
          })
          .catch(() => {
            setState((prevState) => ({ ...prevState, submitting: false }));
          });
      });
    }
  };

  const componentDidUpdate = () => {
    let selectedCourses = []
    switch (hash) {
      case `#${Modals.COURSE}`: {
        if (id) {
          setState((prevState) => ({
            ...prevState,
            visible: true,
            loading: true,
          }));

          API.user
            .details(id)
            .then(async( { data }) => {

              await data.courses.map(item=>{
                selectedCourses.push(parseInt(item))
              })

              form.setFieldsValue({courses: selectedCourses});
            })
            .finally(() => {
              setState((prevState) => ({ ...prevState, loading: false }));
            });
        } else {
          navigate(`${pathname}${search}`, { replace: true });
        }

        break;
      }
      default: {
        if (visible) form.resetFields();

        setState(initialState);

        break;
      }
    }
  };

  useEffect(componentDidUpdate, [hash]);
  
  const onChange = (list) => {
    setCheckedList(list);
  };
  return (
    <Drawer
      className="sp-form-drawer"
      placement={process.env.REACT_APP_IS_RTL ? "left" : "right"}
      footer={
        <>
          <Button type="primary" onClick={handleSubmit} loading={submitting}>
            {Resources.confirm}
          </Button>
          <Button onClick={() => navigate(-1)} disabled={submitting}>
            {Resources.cancel}
          </Button>
        </>
      }
      onClose={() => navigate(-1)}
      title={`${Resources.change} ${Resources.course} "${firstName} ${lastName}"`}
      maskClosable={false}
      open={visible}
      width={414}
    >
      <Form layout="vertical" form={form}>
        {loading ? (
          <Spin className="sp-center-spin" />
        ) : (
          <Form.Item name="courses" required>
            <Checkbox.Group>
              <Row gutter={[16, 8]}>
                {courses.map(({ label, value }) => (
                  <Col xs={24} key={value}>
                    <Checkbox value={value}>{label}</Checkbox>
                  </Col>
                ))}
              </Row>
            </Checkbox.Group>
          </Form.Item>
        )}
      </Form>
    </Drawer>
  );
};

Component.propTypes = {
  data: PropTypes.object,
  onUpdate: PropTypes.func.isRequired,
  options: PropTypes.object.isRequired,
};

export default Component;
